export const isVisible = function (select) {
  let w = $(window)
  let el = $(select)
  if(!el) return false

  let offset = el.offset()
  if(!offset) return false

  return !(w.scrollTop() > (offset.top + el.outerHeight()) || (w.scrollTop() + w.height()) < offset.top)
}

export const isMobileFun = function () {
  const u = navigator.userAgent
  const v = {
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
      iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
  }

  return (v.mobile || v.ios || v.android || v.iPhone || v.iPad)
}


// WEBPACK FOOTER //
// ./src/common/utils.js